
import React from "react";
import ProductPageTemplate from "@/components/ProductPageTemplate";
import { Users, BarChart, LineChart, Target } from "lucide-react";

const PeopleInsights = () => {
  const benefits = [
    {
      title: "Understand Engagement Drivers",
      description: "Identify the key factors that drive employee engagement across different teams, departments, and demographics.",
      icon: <Target className="h-8 w-8" />
    },
    {
      title: "Spot Trends Early",
      description: "Detect emerging patterns in engagement, recognition, and feedback before they impact business outcomes.",
      icon: <LineChart className="h-8 w-8" />
    },
    {
      title: "Make Data-Backed People Decisions",
      description: "Base your HR initiatives and leadership actions on solid data rather than assumptions or anecdotes.",
      icon: <BarChart className="h-8 w-8" />
    },
    {
      title: "Improve Team Experiences",
      description: "Provide leaders with actionable insights to enhance team dynamics, recognition practices, and engagement levels.",
      icon: <Users className="h-8 w-8" />
    }
  ];

  const howItWorks = [
    {
      title: "Access Comprehensive Dashboards",
      description: "Dive into intuitive dashboards that visualize key people metrics across your organization, from engagement trends to recognition patterns, retention indicators to feedback themes.",
      image: "/lovable-uploads/bc45aff0-bfb1-4e56-a1d9-5c102edb829a.png"
    },
    {
      title: "Analyze Multidimensional Data",
      description: "Slice and dice data across multiple dimensions—departments, locations, tenure, roles, and more—to uncover specific insights that matter to your organization.",
      image: "/lovable-uploads/509f3d93-4acd-44aa-b232-0ddf2993d259.png"
    },
    {
      title: "Receive Guided Recommendations",
      description: "Move beyond raw data with AI-powered recommendations that suggest specific actions to address areas of opportunity and build on existing strengths.",
      image: "/lovable-uploads/a52d8591-9cf7-44a6-be3e-89ff2d22b9f5.png"
    }
  ];

  return (
    <ProductPageTemplate
      title="People Insights - Comprehensive HR Analytics"
      description="Assembly's People Insights provides HR leaders with comprehensive analytics on engagement, recognition, retention, and team dynamics to drive data-backed people strategies."
      keywords="HR analytics, people insights, employee engagement analytics, workforce analytics, human resources data, HR data visualization"
      heroTitle="Uncover the Stories Behind Your People Data"
      heroDescription="Assembly's People Insights transforms complex HR data into clear visualizations and actionable recommendations that help you build a more engaged, connected, and high-performing organization."
      featureDescription="People Insights is Assembly's comprehensive analytics solution for HR and people leaders. By aggregating data from across the Assembly platform—recognition, surveys, engagement activities, performance metrics, and more—People Insights delivers a holistic view of your organization's health. With intuitive dashboards, drill-down capabilities, and AI-powered recommendations, you can identify patterns, spot opportunities, and make data-backed decisions to enhance the employee experience."
      benefits={benefits}
      howItWorks={howItWorks}
      ctaText="Ready to unlock deeper insights about your people?"
      ctaButtonText="Request a Demo Today"
      mainImage="/lovable-uploads/42f595b0-c093-4a8f-b25a-190b9e5ea2bd.png"
    />
  );
};

export default PeopleInsights;
